export interface Country {
  code: string;
  name: string;
  icon: string;
  callingCode: string;
}

export const SUPPORTED_COUNTRIES: Country[] = [
  {
    code: 'US',
    name: 'United States',
    icon: '🇺🇸',
    callingCode: '+1',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    icon: '🇬🇧',
    callingCode: '+44',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    icon: '🇳🇱',
    callingCode: '+31',
  },
];

export const DEFAULT_COUNTRY = SUPPORTED_COUNTRIES[0];

// TODO: get rid of libphonenumber dependency
// const defaultPhoneNumber = `+${getCountryCallingCode(DEFAULT_COUNTRY.code)}`;
const defaultPhoneNumber = `+1`;

export const DEFAULT_PHONE_NUMBER = {
  readable: defaultPhoneNumber,
  e164: defaultPhoneNumber,
  valid: false,
};

export const codeBlockLineHeight = 24;
